const complaintSuggesstion = () => import('@/pages/complaint/suggesstion/index')
const complaintRepair = () => import('@/pages/complaint/repair/index')

export default [
    {
        path: '/complaint/suggesstion',
        component: complaintSuggesstion,
        meta: [{
            name: '投诉报修管理',
            url: '/complaint/suggesstion'
        },
        {
            name: '投诉建议列表',
            url: '/complaint/suggesstion'
        }]
    },
    {
        path: '/complaint/repair',
        component: complaintRepair,
        meta: [{
            name: '投诉报修管理',
            url: '/complaint/repair'
        },
        {
            name: '在线报修列表',
            url: '/complaint/repair'
        }]
    }
]